module.exports = __webpack_public_path__ + "static/bearvelour1-2518d0be8851d7721ccb0d0428d82df9.png";